import { useState } from "react";
import { History, Layers, Palette, ShieldCheck } from "lucide-react";
import { Reveal, RevealChevron } from "@/components/common/Reveal";
import { Aparece } from "./Aparece";
import { CONFIANZA, PREGUNTAS } from "./content";

const ICONOS = { aislamiento: ShieldCheck, roles: Layers, cierre: History, marca: Palette };

// Confianza con hechos verificables del producto (nada de "seguridad bancaria") pegada a las
// preguntas frecuentes: son la misma conversación — "¿puedo confiarle mi cartera?".
export const ConfianzaPreguntas = () => {
  const [abierta, setAbierta] = useState(0);
  return (
    <section id="preguntas" className="scroll-mt-16 bg-slate-50" data-testid="landing-preguntas">
      <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6 lg:py-28">
        <ul className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {CONFIANZA.map((c, i) => {
            const Icono = ICONOS[c.key];
            return (
              <Aparece as="li" key={c.key} delay={i * 0.05}>
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-indigo-50">
                  <Icono className="h-5 w-5 text-indigo-600" />
                </span>
                <p className="mt-4 text-base font-bold text-slate-800">{c.titulo}</p>
                <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{c.texto}</p>
              </Aparece>
            );
          })}
        </ul>

        <div className="mt-20 grid gap-10 lg:grid-cols-[1fr_1.6fr]">
          <Aparece>
            <p className="text-xs font-semibold uppercase tracking-widest text-slate-400">Preguntas frecuentes</p>
            <h2 className="mt-3 font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
              Lo que nos preguntan antes de la demo.
            </h2>
          </Aparece>
          <Aparece className="divide-y divide-slate-200 rounded-2xl bg-white px-6 shadow-sm ring-1 ring-inset ring-slate-200/60">
            {PREGUNTAS.map((p, i) => {
              const open = abierta === i;
              const id = `pregunta-${i}`;
              return (
                <div key={p.q}>
                  <h3>
                    <button
                      type="button"
                      className="flex w-full cursor-pointer items-center justify-between gap-4 py-5 text-left text-base font-semibold text-slate-800 transition-colors duration-200 hover:text-indigo-700 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-indigo-100"
                      aria-expanded={open}
                      aria-controls={id}
                      onClick={() => setAbierta(open ? -1 : i)}
                    >
                      {p.q}
                      <RevealChevron open={open} deg={90} className="h-5 w-5 shrink-0 text-slate-400" />
                    </button>
                  </h3>
                  <Reveal open={open} className="pb-5" testId={id}>
                    {() => (
                      <p id={id} className="text-sm leading-relaxed text-slate-600">{p.a}</p>
                    )}
                  </Reveal>
                </div>
              );
            })}
          </Aparece>
        </div>
      </div>
    </section>
  );
};
